import React, { Fragment, useEffect, useState } from "react";
import Slider from "react-slick";
import { callAPI } from "../../../../../axios";
import { getChainIdLS } from "../../../../../utils/utils";
import { CircularProgress, MenuItem, Select } from "@mui/material";
import { Tabs, Tab, Box, AppBar } from "@mui/material";
import { BiUser } from "react-icons/bi";
import { MdNotificationsNone } from "react-icons/md";
import { GoGear, GoMail, GoGraph } from "react-icons/go";
import headerLogo from "../../../../../assets/images/logo-preview.png";
import { CiSearch } from "react-icons/ci";
import { FaChromecast } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoNewspaperOutline, IoAirplaneOutline } from "react-icons/io5";

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
        className: `eachtab`,
    };
}

const RailConfigPreview = (props) => {

    const { previewUtilityData,showUtility, tabs, previewListRowData, listPreview, onCreateRailConfigPreview, previewPartnerData, previewChannelData, editPublishUnPublish, onSubmitHandler, previewHotelServiceData, previewHotelChannelData } = props

    const [previewRes, setPreviewRes] = useState({});
    const [roomType, setRoomType] = useState(previewListRowData?.roomTypes[0]);
    const [loader, setLoader] = useState(true);

    const boxStyle = {
        position: "absolute",
        backgroundColor: '#000000',
        zIndex: "1",
        height: "3vh",
        width: "100%",
        boxShadow: "0 13px 23px #000",
    };

    // const boxStyle2 = {
    //     position: "absolute",
    //     backgroundColor: '#000000',
    //     zIndex: "1",
    //     height: "65vh",
    //     width: "27%",
    //     boxShadow: "140px 0px 94px #000",
    // };

    useEffect(() => {
        callAPI(`/preview?roomType=${roomType}&sid=${previewListRowData?.sid ? previewListRowData?.sid : ''}`, "GET", {}, { chainId: getChainIdLS() })
            .then((res) => {
                setPreviewRes(res);
                // setLoader(false)
                setTimeout(() => setLoader(false), [1000])
            })
            .catch((err) => {
                console.warn(err.message);
                // setLoader(false)
                setTimeout(() => setLoader(false), [1000])
            });
    }, [roomType]);

    const settings = {
        dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
    };

    const railsSettings = {
        dots: false,
        arrows: false,
        speed: 500,
        slidesToShow: 9,
        draggable: false,
        swipe: false,
        infinite: false
    };

    const channelsSettings = {
        dots: false,
        speed: 500,
        slidesToShow: 9,
        arrows: false,
        draggable: false,
        swipe: false,
        infinite: false
    };

    const HotelServiceSettings = {
        dots: false,
        arrows: false,
        speed: 500,
        slidesToShow: 5,
        draggable: false,
        swipe: false,
        infinite: false
    };

    return (
        <Fragment>
            {loader ? <div className="p-3"><div className="circular-progress"><CircularProgress /></div></div> : <div className="text-start">
                <div className="rail-config-preview">
                    <div className="rail-name">
                        <h6>Rail Configuration Name: {previewListRowData?.railName}</h6>
                        <div className="room-type">
                            <label name='roomType'>Room Type: </label>
                            <Select
                                value={roomType}
                                onChange={(e) => setRoomType(e.target.value)}
                                className="select-room-type"
                            >
                                {previewListRowData?.roomTypes.map((roomType) => (
                                    <MenuItem key={roomType} value={roomType}>
                                        {roomType}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                    </div>
                    <p onClick={() => props.setPreview(false)}>X</p>
                </div>
                <div className="preview-bg">
                    {
                        listPreview && <>
                            {previewRes?.heroBannerConfiguration?.length > 0 && <div className="mb-3 banner-image">
                                <div style={boxStyle}></div>
                                {/* <div style={boxStyle2}></div> */}
                                {previewRes?.heroBannerConfiguration?.length > 1 ? <Slider {...settings}>
                                    {previewRes?.heroBannerConfiguration?.map((img, index) =>
                                        <img src={img} alt={index} />
                                    )}
                                </Slider> : <img src={previewRes?.heroBannerConfiguration} alt='hero-banner' />}
                                <div className="preview-header">
                                    <div className="header">
                                        <div className="logos">
                                            <img src={headerLogo} alt="header logo" className="main-logo" />
                                        </div>
                                        <div className="header-icons">
                                            <CiSearch />
                                            <MdNotificationsNone />
                                            <GoMail />
                                            <GoGear />
                                            <BiUser />
                                        </div>
                                    </div>
                                    <Box className="cdsn-boxroot mt-3">
                                        <AppBar position="static">
                                            <Tabs
                                                // variant="scrollable"
                                                TabIndicatorProps={{
                                                    hidden: true,
                                                    style: { transition: "none" },
                                                }}
                                            >
                                                <Tab label="Home" {...a11yProps(0)} className="Mui-selected eachtab" />
                                                <Tab label="Tv Channels" {...a11yProps(1)} />
                                                <Tab label="Binge" {...a11yProps(2)} />
                                                <Tab label="Apps" {...a11yProps(3)} />
                                            </Tabs>
                                        </AppBar>
                                    </Box>
                                    {/* <div className="preview-welcome-msg">
                                        <a rel="noopener noreferrer">View Now</a>
                                    </div> */}
                                </div>
                            </div>
                            }
                            {previewRes?.railConfiguration?.railOrder?.map((tabData) => {
                                if (tabData?.railName === "partner") {
                                    return (
                                        <>
                                            {previewRes?.railConfiguration?.partnerConfiguration?.length > 0 && <div className="partner-rails">
                                                <p>OTT Apps</p>
                                                < Slider {
                                                    ...{
                                                        ...railsSettings,
                                                        arrows: previewRes?.railConfiguration?.partnerConfiguration?.length > 9,
                                                    }
                                                }
                                                    className="mx-4"
                                                >
                                                    {previewRes?.railConfiguration?.partnerConfiguration?.sort((a, b) => a.sequenceNo - b.sequenceNo)?.map((list, index) =>
                                                        <img src={list?.logoUrl} alt={list?.sequenceNo} className="ott-apps" />
                                                    )}
                                                </Slider>

                                            </div>}
                                        </>
                                    )
                                }
                                else if (tabData?.railName === "linearChannel") {
                                    return (
                                        <>
                                            {previewRes?.railConfiguration?.channelConfiguration?.length > 0 &&
                                                <div className="partner-rails">
                                                    <p>Tata play Linear Channels</p>
                                                    {previewRes?.railConfiguration?.channelConfiguration?.map((channelConfig) =>
                                                        <div className="channel-categories">
                                                            <h6>{channelConfig?.categoryName}</h6>
                                                            <Slider   {...{
                                                                ...channelsSettings,
                                                                arrows: channelConfig?.channels?.length > 9,
                                                            }}
                                                                className="mx-4"
                                                            >
                                                                {channelConfig?.channels?.sort((a, b) => a.sequenceNo - b.sequenceNo)?.map((list, index) =>
                                                                    <img src={list?.thumbnailImageUrl} alt={list?.sequenceNo} />
                                                                )}
                                                            </Slider>
                                                        </div>
                                                    )}
                                                </div>
                                            }
                                        </>
                                    )
                                }
                                else if (tabData?.railName === "hotelChannel") {
                                    return (
                                        <>
                                            {previewRes?.railConfiguration?.hotelChannelPreview?.length > 0 && <div className="partner-rails">
                                                <p>Hotel Channels</p>
                                                < Slider {
                                                    ...{
                                                        ...railsSettings,
                                                        arrows: previewRes?.railConfiguration?.hotelChannelPreview?.length > 9,
                                                    }
                                                }
                                                    className="mx-4"
                                                >
                                                    {previewRes?.railConfiguration?.hotelChannelPreview?.sort((a, b) => a.sequenceNo - b.sequenceNo)?.map((list, index) =>
                                                        <div className="hotel-channels">
                                                            <img src={list?.thumbnailImageUrl} alt={list?.sequence} />
                                                            {/* <p>{list?.channelName}</p> */}
                                                        </div>
                                                    )}
                                                </Slider>

                                            </div>
                                            }
                                        </>
                                    )
                                }
                                else if (tabData?.railName === "hotelService") {
                                    return (
                                        <>
                                            {previewRes?.railConfiguration?.hotelServicePreview?.length > 0 && <div className="partner-rails mt-2">
                                                <p>Hotel Service</p>
                                                < Slider {
                                                    ...{
                                                        ...HotelServiceSettings,
                                                        arrows: previewRes?.railConfiguration?.hotelServicePreview?.length > 5,
                                                    }
                                                }
                                                    className="mx-4"
                                                >
                                                    {previewRes?.railConfiguration?.hotelServicePreview?.sort((a, b) => a.sequenceNo - b.sequenceNo)?.map((list, index) =>
                                                        <div className="hotel-rails-img">
                                                            <div className="position-relative">
                                                                <img src={list?.thumbnailImageUrl} alt={list?.sequenceNo} />
                                                                <p className="hotel-service-title">{list?.name}</p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Slider>

                                            </div>
                                            }
                                        </>
                                    )
                                }
                                if (previewRes?.railConfiguration?.showUtilities) {
                                    return (
                                        <>
                                            {/* {previewRes?.railConfiguration?.utilityConfiguration?.length > 0 && <div className="partner-rails">
                                                <p>Utilities</p>
                                                < Slider {
                                                    ...{
                                                        ...railsSettings,
                                                        arrows: previewRes?.railConfiguration?.utilityConfiguration?.length > 9,
                                                    }
                                                }
                                                    className="mx-4"
                                                >
                                                    {previewRes?.railConfiguration?.utilityConfiguration?.sort((a, b) => a.sequenceNo - b.sequenceNo)?.map((list, index) =>
                                                        <img src={list?.thumbnailUrl} alt={list?.sequenceNo} />
                                                    )}
                                                </Slider>

                                            </div>} */}
                                            <p>Utilities</p>
                                            <div className="cost-devices">
                                                <div>
                                                    <FaChromecast />
                                                    <p>Cast Your Device</p>
                                                </div>
                                                <div>
                                                    <RiDeleteBin5Line />
                                                    <p>Clear App Credentials</p>
                                                </div>
                                                <div>
                                                    <IoNewspaperOutline />
                                                    <p>News Updates</p>
                                                </div>
                                                <div>
                                                    <IoAirplaneOutline />
                                                    <p>Flight Status</p>
                                                </div>
                                                <div>
                                                    <GoGraph />
                                                    <p>Market Updates</p>
                                                </div>
                                            </div>
                                        </>
                                    )
                                }
                            })}
                        </>
                    }
                    {
                        onCreateRailConfigPreview && <>
                            {previewRes?.heroBannerConfiguration?.length > 0 && <div className="mb-3 banner-image">
                                <div style={boxStyle}></div>
                                {previewRes?.heroBannerConfiguration?.length > 1 ? <Slider {...settings}>
                                    {previewRes?.heroBannerConfiguration?.map((img, index) =>
                                        <img src={img} alt={index} />
                                    )}
                                </Slider> : <img src={previewRes?.heroBannerConfiguration} alt='hero-banner' />}
                                <div className="preview-header">
                                    <div className="header mt-3">
                                        <div className="logos">
                                            <img src={headerLogo} alt="header logo" className="main-logo" />
                                        </div>
                                        <div className="header-icons">
                                            <CiSearch />
                                            <MdNotificationsNone />
                                            <GoMail />
                                            <GoGear />
                                            <BiUser />
                                        </div>
                                    </div>
                                    <Box className="cdsn-boxroot mt-3">
                                        <AppBar position="static">
                                            <Tabs
                                                // variant="scrollable"
                                                TabIndicatorProps={{
                                                    hidden: true,
                                                    style: { transition: "none" },
                                                }}
                                            >
                                                <Tab label="Home" {...a11yProps(0)} className="Mui-selected eachtab" />
                                                <Tab label="Tv Channels" {...a11yProps(1)} />
                                                <Tab label="Binge" {...a11yProps(2)} />
                                                <Tab label="Apps" {...a11yProps(3)} />
                                            </Tabs>
                                        </AppBar>
                                    </Box>
                                    {/* <div className="preview-welcome-msg">
                                        <a rel="noopener noreferrer">View Now</a>
                                    </div> */}
                                </div>
                            </div>
                            }
                            {tabs?.map((tabData) => {
                                if (tabData?.railName === "partner") {
                                    return (
                                        <>
                                            {previewPartnerData?.length > 0 &&
                                                <div className="partner-rails">
                                                    <p>OTT Apps</p>
                                                    < Slider {...{
                                                        ...railsSettings,
                                                        arrows: previewPartnerData?.length > 9,
                                                    }}
                                                        className="mx-4"
                                                    >
                                                        {previewPartnerData?.map((list) =>
                                                            <img src={list?.logo} alt={list?.name} className="ott-apps" />
                                                        )}
                                                    </Slider>
                                                </div>}
                                        </>
                                    )
                                }
                                else if (tabData?.railName === "linearChannel") {
                                    return (
                                        <>
                                            {previewChannelData?.length > 0 &&
                                                <div className="partner-rails">
                                                    <p>Tata play Linear Channels</p>
                                                    {previewChannelData?.map((channelConfig) =>
                                                        <div className="channel-categories">
                                                            <h6>{channelConfig?.categoryName}</h6>

                                                            <Slider  {...{
                                                                ...channelsSettings,
                                                                arrows: channelConfig?.channels?.length > 9,
                                                            }}
                                                                className="mx-4">
                                                                {channelConfig?.channels?.map((list) =>
                                                                    <img src={list?.logo} alt={list?.name} />
                                                                )}
                                                            </Slider>
                                                        </div>
                                                    )}
                                                </div>
                                            }
                                        </>
                                    )
                                }
                                else if (tabData?.railName === "hotelChannel") {
                                    return (
                                        <>
                                            {previewHotelChannelData?.length > 0 &&
                                                <div className="partner-rails">
                                                    <p>Hotel Channels</p>
                                                    < Slider {...{
                                                        ...railsSettings,
                                                        arrows: previewHotelChannelData?.length > 9,
                                                    }}
                                                        className="mx-4"
                                                    >
                                                        {previewHotelChannelData?.map((list) =>
                                                            <div className="hotel-channels">
                                                                <img src={list?.logo} alt={list?.name} />
                                                                {/* <p>{list?.name}</p> */}
                                                            </div>
                                                        )}
                                                    </Slider>
                                                </div>
                                            }
                                        </>
                                    )
                                }
                                else if (tabData?.railName === "hotelService") {
                                    return (
                                        <>
                                            {previewHotelServiceData?.length > 0 &&
                                                <div className="partner-rails mt-2">
                                                    <p>Hotel Service</p>
                                                    < Slider {...{
                                                        ...HotelServiceSettings,
                                                        arrows: previewHotelServiceData?.length > 5,
                                                    }}
                                                        className="mx-4"
                                                    >
                                                        {previewHotelServiceData?.map((list) =>
                                                            <div className="hotel-rails-img">
                                                                <div className="position-relative">
                                                                    <img src={list?.logo} alt={list?.name} />
                                                                    <p className="hotel-service-title">{list?.name}</p>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Slider>
                                                </div>
                                            }
                                        </>
                                    )
                                }
                                else if (tabData?.railName === "utility") {
                                    return (
                                        <>
                                            {/* {previewUtilityData?.length > 0 &&
                                                <div className="partner-rails">
                                                    <p>Utilities</p>
                                                    < Slider {...{
                                                        ...railsSettings,
                                                        arrows: previewUtilityData?.length > 9,
                                                    }}
                                                        className="mx-4"
                                                    >
                                                        {previewUtilityData?.map((list) =>
                                                            <img src={list?.logo} alt={list?.name} />
                                                        )}
                                                    </Slider>
                                                </div>} */}
                                                {showUtility && <p>Utilities</p>}
                                            {showUtility &&<div className="cost-devices">
                                                <div>
                                                    <FaChromecast />
                                                    <p>Cast Your Device</p>
                                                </div>
                                                <div>
                                                    <RiDeleteBin5Line />
                                                    <p>Clear App Credentials</p>
                                                </div>
                                                <div>
                                                    <IoNewspaperOutline />
                                                    <p>News Updates</p>
                                                </div>
                                                <div>
                                                    <IoAirplaneOutline />
                                                    <p>Flight Status</p>
                                                </div>
                                                <div>
                                                    <GoGraph />
                                                    <p>Market Updates</p>
                                                </div>
                                            </div> }
                                        </>
                                    )
                                }
                            })}

                            {/* {onCreateRailConfigPreview && <div className="text-end mt-3">
                        <button
                            onClick={() => onSubmitHandler(false)}
                            type="button"
                            className="disable-btn ms-2"
                        >
                            {editPublishUnPublish ? "Update" : "Create"} Rail
                        </button>
                        <button
                            onClick={() => onSubmitHandler(true)}
                            type="button"
                            className="create-btn ms-2"
                        >
                            Publish Rail
                        </button>
                    </div>} */}
                        </>
                    }
                </div>
            </div >}
        </Fragment>
    )
}

export default RailConfigPreview;